//报名配置
const state = {
  configItem:{},
  outOrderNo:''
}

const mutations = {
  setEnrollKey(state, { key, value }) {
    state[key] = value
  },
  setConfigId(state,{ key, value }){
    state.configItem[key] = value
  }
}

const actions = {

}

const getters = {
  configItem: state => state.configItem,
  outOrderNo: state => state.outOrderNo
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}